import InputFile from './InputFile.jsx';

export default function FormInputFile({
    label,
    accept,
    type, 
    name,
    disabled,
    required,
    onChange,
    labelRequire=true,
    classname="",
}) {
    return (
        <>
            <InputFile 
                label={label}
                accept={accept}
                name={name}
                type={type}
                disabled={disabled} 
                required={required} 
                onChange={onChange}
                labelRequire={labelRequire}
                classname={classname}
            />
        </>
    )
}
